var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsOutpostsServers32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Scout_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Scout_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Scout_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.997,21.4861754 C28.997,20.6591754 28.324,19.9861754 27.497,19.9861754 L8.497,19.9861754 C7.67,19.9861754 6.997,20.6591754 6.997,21.4861754 L6.997,23.4861754 C6.997,24.3131754 7.67,24.9861754 8.497,24.9861754 L27.497,24.9861754 C28.324,24.9861754 28.997,24.3131754 28.997,23.4861754 L28.997,21.4861754 Z M29.997,21.4861754 L29.997,23.4861754 C29.997,24.8641754 28.876,25.9861754 27.497,25.9861754 L8.497,25.9861754 C7.118,25.9861754 5.997,24.8641754 5.997,23.4861754 L5.997,21.4861754 C5.997,20.1081754 7.118,18.9861754 8.497,18.9861754 L27.497,18.9861754 C28.876,18.9861754 29.997,20.1081754 29.997,21.4861754 L29.997,21.4861754 Z M9.997,22.9861754 L10.997,22.9861754 L10.997,21.9861754 L9.997,21.9861754 L9.997,22.9861754 Z M11.997,22.9861754 L14.997,22.9861754 L14.997,21.9861754 L11.997,21.9861754 L11.997,22.9861754 Z M15.997,22.9861754 L25.997,22.9861754 L25.997,21.9861754 L15.997,21.9861754 L15.997,22.9861754 Z M5.617,11.7831754 C5.617,11.9661754 5.629,12.1471754 5.649,12.3231754 C5.68,12.5721754 5.52,12.8051754 5.277,12.8671754 C4.445,13.0791754 3.05,13.7341754 3.05,15.7351754 L3.055,15.9331754 C3.099,16.8421754 3.431,18.4091754 5.143,18.6411754 L5.009,19.6321754 C3.261,19.3951754 2.156,18.0291754 2.056,15.9781754 L2.05,15.7351754 C2.05,13.9541754 3.003,12.5921754 4.622,12.0211754 C4.619,11.9421754 4.617,11.8631754 4.617,11.7831754 C4.617,9.7601754 5.972,7.6621754 7.768,6.9011754 C9.875,6.0111754 12.098,6.4541754 13.726,8.0861754 C14.188,8.5501754 14.575,9.1051754 14.879,9.7411754 C15.48,9.3101754 16.238,9.1661754 16.959,9.3781754 C17.999,9.6811754 18.704,10.6131754 18.889,11.9011754 C19.967,12.1421754 21.997,12.9481754 21.997,16.7261754 L20.997,16.7261754 C20.997,13.6811754 19.651,13.0391754 18.335,12.8131754 C18.066,12.7671754 17.885,12.5151754 17.926,12.2451754 C17.857,11.2851754 17.391,10.5461754 16.678,10.3381754 C16.106,10.1691754 15.483,10.3951754 15.101,10.9111754 C14.992,11.0601754 14.813,11.1331754 14.625,11.1091754 C14.442,11.0821754 14.289,10.9551754 14.227,10.7811754 C13.946,9.9841754 13.539,9.3151754 13.018,8.7921754 C12.379,8.1521754 10.625,6.7751754 8.159,7.8221754 C6.733,8.4251754 5.617,10.1651754 5.617,11.7831754 L5.617,11.7831754 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsOutpostsServers32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Outposts-servers_32.15e85863e96ddf4b1c059790eeebe1d6.svg";
export { ForwardRef as ReactComponent };